import api from './index';

export const authAPI = {
  login: (data) => {
    return api.post('/api/auth/login', data);
  },
  register: (data) => {
    return api.post('/api/auth/register', data);
  },
  sendCode: (phone, scene = 'login') => {
    return api.post('/api/auth/send-code', { phone, scene });
  },
  loginByCode: (data) => {
    return api.post('/api/auth/login-by-code', data);
  },
  registerByCode: (data) => {
    return api.post('/api/auth/register-by-code', data);
  },
  logout: () => {
    return api.post('/api/auth/logout');
  }
};